module.exports = "<div ui-view>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/maneuver/move/templates/index.html
// module id = 1584
// module chunks = 0